import WrapperService from "@/modules/core/services/wrapper-service";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/facility/elevatorstate"

const serviceName = "ElevatorState-Service: ";

export default class ElevatorStateService {
  static async readFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id, null, serviceName, successF, errorF);
  }

  static putToAPI(state, successF, errorF) {
    return WrapperService.put(API_URL + "/" + state.facility, state, serviceName, successF, errorF);
  }
}